import { MainLayout } from '../../design-system/Templates';
import { Header } from '@/design-system/Organisms';
import { headerConfig } from '@/design-system/Organisms/Header/Header.config';
import { Footer } from '@/design-system/Organisms';
import { HeroBanner } from '@/design-system/Organisms';
import { HomePageTemplate } from '@/design-system/Templates';
import { homeHeroData } from '@/design-system/Organisms/HeroBanner/heroBanner.data';

const HomePage = () => {

  return (
    <MainLayout
      header={<Header {...headerConfig} />}
      sidebar={null}
      className=""
      footer={<Footer />}
      topBanner={<HeroBanner {...homeHeroData} />}
    >
      <HomePageTemplate />
    </MainLayout >
  );
};

export default HomePage;
